import { z } from 'zod';
import { PRODUCT_TREE_CONSTRAINTS } from './constraints.js';
// Flat, string-typed form schema for RHF -- see packages/shared/src/validation/brand/create-form.ts
// for the split this follows. brandId/parentId stay z.string() (not the UUID-typed schema used by
// create-input.ts) so an empty DimeAutocomplete selection round-trips as '' rather than undefined.
export const productTreeCreateFormSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${PRODUCT_TREE_CONSTRAINTS.name.label} is required`)
        .max(PRODUCT_TREE_CONSTRAINTS.name.maxLength, `${PRODUCT_TREE_CONSTRAINTS.name.label} must be ${PRODUCT_TREE_CONSTRAINTS.name.maxLength} characters or fewer`),
    description: z
        .string()
        .trim()
        .max(PRODUCT_TREE_CONSTRAINTS.description.maxLength, `${PRODUCT_TREE_CONSTRAINTS.description.label} must be ${PRODUCT_TREE_CONSTRAINTS.description.maxLength} characters or fewer`),
    brandId: z.string().trim().min(1, 'Brand is required.'),
    parentId: z.string(),
});
export function emptyProductTreeCreateFormValues(defaults) {
    return { name: '', description: '', brandId: '', parentId: '', ...defaults };
}
//# sourceMappingURL=create-form.js.map